import i18n from 'i18n/i18n';
import _ from 'lodash';
const localize = i18n.loc.localize;

const schema = {
	'mlsSystem': (object, state, includeAllField) => {
		if (state.touched['mlsSystem'] || includeAllField) {
			if (!(_.get(object, 'value', '') || '').trim()) {
				return localize('required-field');
			}
		}		
	},	
	'mlsSystemCustom': (value, state, includeAllField) => {
		if (state.touched['mlsSystemCustom'] || includeAllField) {
			if (!(value || '').trim()) {
				return localize('required-field');
			}
		}		
	},	
	'mlsOfficeId': (value, state, includeAllField) => {
		if (state.touched['mlsOfficeId'] || includeAllField) {
			if (!(value || '').trim()) {
				return localize('required-field');
			}
		}
	},
	'agentMlsId': (value, state, includeAllField) => {
		if (state.touched['agentMlsId'] || includeAllField) {
			if (!(value || '').trim()) {
				return localize('required-field');
			}
		}
	}	
};

export default schema;


// WEBPACK FOOTER //
// ./src/components/Modal/AddMlsConnectionModalSchema.js